import styled from "styled-components";

export const Container = styled.label`
    font-weight: 400;
    margin-top: 15px;
    margin-left: 5px;
`;